export var extractUrlFromLinkJsonLd = function extractUrlFromLinkJsonLd(link) {
  if (typeof link === 'string') {
    return link;
  } else if (Array.isArray(link)) {
    if (link.length > 0) {
      return extractUrlFromLinkJsonLd(link[0]);
    }
  } else {
    return link.href;
  }
};